const messages = {
  en: {
    global: {
      table: 'Table',
      filter: 'Filter',
      reload: 'Reload',
      export: 'Export',
      import: 'Import',
      visibility: 'Visibility',
      add_new: 'Add New',
      update: 'Edit',
      delete: 'Delete',
      delete_all: 'Delete All',
      detail: 'Detail',
      prev: 'Prev',
      next: 'Next',
      goto: 'Go to',
      display: 'Displaying',
      of: 'of',
      record: 'record',
      loading: 'Loading',
      search: 'Search in table',
      search_label: 'Search',
      filter_label: 'Showing result',
      go_back: 'Back to previous page',
      form_add: 'Form add new',
      form_edit: 'Form update',
      form_filter: 'Filter data',
      file_name: 'File Name',
      size: 'Size',
      type: 'File Type',
      select_multiple: 'Please select a few',
      select_single: 'Please select',
      select_all: 'Select All in this page',
      selected: 'Select Item',
      select_save: 'Save selected item',
      unselected: 'Anda belum memilih',
      submit: 'Submit'
    },
    error: {
      view_type: 'No visualization for this type',
      no_data: 'Sorry, no options found for this field.'
    },
    hint: {
      upload: 'Click image to select a file to upload',
      failed_upload: 'File upload canceled',
      max_size: 'Maximum file size',
      max_file: 'Maximum uploaded file'
    },
    bag: {
      proyek: 'Project',
      m_proyek: 'Project Master',
      departemen: 'Department',
      pengguna: 'User',
      unit_kerja: 'Unit Kerja'
    }
  },
  id: {
    global: {
      table: 'Tabel',
      filter: 'Filter',
      reload: 'Muat Ulang',
      export: 'Ekspor',
      import: 'Impor',
      visibility: 'Tampilkan Kolom',
      add_new: 'Tambah Baru',
      update: 'Edit',
      delete: 'Hapus',
      delete_all: 'Hapus Semua',
      detail: 'Detail',
      prev: 'Sebelumnya',
      next: 'Selanjutnya',
      goto: 'Halaman',
      display: 'Menampilkan',
      of: 'dari',
      record: 'data',
      loading: 'Memuat',
      search: 'Cari',
      search_label: 'Pencarian',
      filter_label: 'Menampilkan hasil',
      go_back: 'Kembali ke halaman sebelumnya',
      form_add: 'Formulir Tambah Baru',
      form_edit: 'Formulir edit data',
      form_filter: 'Filter data',
      file_name: 'Nama File',
      size: 'Ukuran',
      type: 'Tipe File',
      select_multiple: 'Pilih beberapa',
      select_single: 'Pilih salah satu',
      select_all: 'Pilih semua di halaman ini',
      selected: 'Item Terpilih',
      select_save: 'Simpan item',
      unselected: 'Anda belum memilih',
      submit: 'Simpan'
    },
    error: {
      view_type: 'Maaf, tidak ada visualisasi untuk tipe ini',
      no_data: 'Maaf, opsi data tidak ditemukan'
    },
    hint: {
      upload: 'Klik gambar untuk memilih berkas yang akan diunggah',
      failed_upload: 'Upload berkas dibatalkan',
      max_size: 'Ukuran berkas maksimal',
      max_file: 'Jumlah file maksimal'
    },
    bag: {
      proyek: 'Proyek',
      m_proyek: 'Master Proyek',
      departemen: 'Departemen',
      pengguna: 'Pengguna',
      unit_kerja: 'Unit Kerja'
    }
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/utils/translate.js